import React, {FC, useState, useEffect} from "react";
import Typography from "@material-ui/core/Typography";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    FormControl,
    Grid,
    makeStyles,
    MenuItem,
    Select
} from "@material-ui/core";
import {AdequacyTypeID, IAdequacy, IControlMeasureAssessment} from "../types/types";
import {  useTask } from '../stateManagement/context';


interface IAdequacyProps {
    adequacies:IAdequacy[];
    initial_value: string;
    updateCallback: (selected_id: number) => void;
    type_id: AdequacyTypeID;
}



const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 250,
        maxWidth: 250,
    },
    menu:{
        minWidth: 250,
        maxWidth: 250,
    },
    listItem: {
        whiteSpace: "normal",
        fontSize: "11pt"
    }
}));

const AdequacySelection: FC<IAdequacyProps> = ({adequacies,
                                                type_id,
                                                   initial_value,
                                                   updateCallback}) => {


    const  [selected, setSelected] = useState(initial_value);

    const [filteredAdequacies, setFilteredAdequacies] = useState(
        adequacies.filter(a=>a.type_id===type_id))
        
    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])


    const classes = useStyles();
    return (
        <div>

            <FormControl className={classes.formControl} size="small">
            <Select
                style={{fontSize:"11pt"}}
                multiline={true}
                MenuProps={{className: classes.menu}}
                value={selected}
                disabled={!write_access}
                onChange={ (event) => {
                    setSelected(event.target.value as string)
                    let s = event.target.value as string
                    if (s) {
                        updateCallback(parseInt(s))
                    }
                }}>
                {Array.from(filteredAdequacies).map((d, i) => {
                    return <MenuItem className={classes.listItem} value={d.id}>{d.name}</MenuItem>
                })}
            </Select>
            </FormControl>
        </div>
    );
}

export default AdequacySelection;
